import request from "../../utils/request";
// 业务数据
/**
 * 获取租车情况-汇总统计
 * @param {object} params
 * @param {int} params.begin         -查询日期起 必填
 * @param {int} params.end           -查询日期止 必填
 * @param {int} params.localTags     -是否本校 0 本校 1 非本校 -1 全部 必填
 * @param {int} params.stage         -科目 全部0 必填
 * @param {int} params.unitId        -单位ID 必填
 * @param {string} params.vehType    -车型 必填
 */
export function getTrainByVehCostSum(params) {
  return request("/report/getTrainByVehCostSum", {
    method: "get",
    params: params,
  });
}

/**
 * 教练提成按月汇总-列表
 * @param {object} params
 * @param {int} params.begin         -查询日期起 必填
 * @param {int} params.end           -查询日期止 必填
 * @param {int} params.unitId        -单位ID 必填
 */
export function teaCommision(params) {
  return request("/report/teaCommision", {
    method: "get",
    params: params,
  });
}

/**
 * 教练提成明细-列表
 * @param {object} params
 * @param {int} params.begin         -查询日期起 必填
 * @param {int} params.end           -查询日期止 必填
 * @param {int} params.unitId        -单位ID 必填
 */
export function teaCommisionDetail(params) {
  return request("/report/teaCommisionDetail", {
    method: "get",
    params: params,
  });
}

/**
 * 教练提成明细-汇总统计
 * @param {object} params
 * @param {int} params.begin         -查询日期起 必填
 * @param {int} params.end           -查询日期止 必填
 * @param {int} params.unitId        -单位ID 必填
 */
export function teaCommisionDetailSum(params) {
  return request("/report/teaCommisionDetailSum", {
    method: "get",
    params: params,
  });
}

/**
 * 获取短训数据列表
 * @param {object} params
 * @param {int} params.begin         -查询日期起 必填
 * @param {int} params.end           -查询日期止 必填
 * @param {int} params.localTags     -是否本校 0 本校 1 非本校 -1 全部 必填
 * @param {int} params.stage         -科目 全部0 必填
 * @param {int} params.unitId        -单位ID 必填
 * @param {string} params.vehType    -车型 必填
 * @param {int} params.purchaseType  -支付类型 1 现金支付 2 团购核销 3 历史核销 -1 全部
 */
export function trainByDay(params) {
  return request("/report/trainByDay", {
    method: "get",
    params: params,
  });
}

/**
 * 获取租车情况-列表
 * @param {object} params
 * @param {int} params.begin         -查询日期起 必填
 * @param {int} params.end           -查询日期止 必填
 * @param {int} params.localTags     -是否本校 0 本校 1 非本校 -1 全部 必填
 * @param {int} params.stage         -科目 全部0 必填
 * @param {int} params.unitId        -单位ID 必填
 * @param {string} params.vehType    -车型 必填
 */
export function trainByDayDetail(params) {
  return request("/report/trainByDayDetail", {
    method: "get",
    params: params,
  });
}

/**
 * 短训日报-列表
 * @param {object} params
 * @param {int} params.date         -查询日期起 必填
 * @param {int} params.dateEnd           -查询日期止 必填
 * @param {int} params.localTags     -是否本校 0 本校 1 非本校 -1 全部 必填
 * @param {int} params.stage         -科目 全部0 必填
 * @param {int} params.unitId        -单位ID 必填
 * @param {string} params.vehType    -车型 必填
 * @param {string} params.pageIndex    -当前页 必填
 * @param {string} params.pageSize     -每页数量 必填
 * @param {int} params.purchaseType  -支付类型 1 现金支付 2 团购核销 3 历史核销 -1 全部
 */
export function trainDaily(params) {
  return request("/report/trainDaily", {
    method: "get",
    params: params,
  });
}

/**
 * 短训日报-汇总统计
 * @param {object} params
 * @param {int} params.date         -查询日期起 必填
 * @param {int} params.dateEnd           -查询日期止 必填
 * @param {int} params.localTags     -是否本校 0 本校 1 非本校 -1 全部 必填
 * @param {int} params.stage         -科目 全部0 必填
 * @param {int} params.unitId        -单位ID 必填
 * @param {string} params.vehType    -车型 必填
 * @param {int} params.purchaseType  -支付类型 1 现金支付 2 团购核销 3 历史核销 -1 全部
 */
export function trainDailySum(params) {
  return request("/report/trainDailySum", {
    method: "get",
    params: params,
  });
}

/**
 * 短训日报-总数
 * @param {object} params
 * @param {int} params.date         -查询日期起 必填
 * @param {int} params.dateEnd           -查询日期止 必填
 * @param {int} params.localTags     -是否本校 0 本校 1 非本校 -1 全部 必填
 * @param {int} params.stage         -科目 全部0 必填
 * @param {int} params.unitId        -单位ID 必填
 * @param {string} params.vehType    -车型 必填
 * @param {int} params.purchaseType  -支付类型 1 现金支付 2 团购核销 3 历史核销 -1 全部
 */
export function trainDailyCount(params) {
  return request("/report/trainDailyCount", {
    method: "get",
    params: params,
  });
}
/**
 * 短训月报-列表
 * @param {object} params
 * @param {int} params.date          -查询日期 必填
 * @param {int} params.localTags     -是否本校 0 本校 1 非本校 -1 全部 必填
 * @param {int} params.stage         -科目 全部0 必填
 * @param {int} params.unitId        -单位ID 必填
 * @param {string} params.vehType    -车型 必填
 */
export function trainMonth(params) {
  return request("/report/trainMonth", {
    method: "get",
    params: params,
  });
}

/**
 * 销售日报-列表
 * @param {object} params
 * @param {int} params.eId          -eId
 * @param {int} params.begin        -开始时间
 * @param {int} params.end          -结束时间
 * @param {int} params.stage        -科目 0 全部 2 科目2 3 科目3
 * @param {int} params.purchaseType -支付类型 1 现金支付 2 团购核销 3 历史核销 -1 全部
 */
export function getSalesDailySumByFaxed(params) {
  return request("/report/getSalesDailySumByFaxed", {
    method: "post",
    params: params,
  });
}

/**
 * 销售日报-总数
 * @param {object} params
 * @param {int} params.eId          -eId
 * @param {int} params.begin        -开始时间
 * @param {int} params.end          -结束时间
 * @param {int} params.stage        -科目 0 全部 2 科目2 3 科目3
 * @param {int} params.purchaseType -支付类型 1 现金支付 2 团购核销 3 历史核销 -1 全部
 */
export function getSalesDailyTotal(params) {
  return request("/report/getSalesDailyTotal", {
    method: "post",
    params: params,
  });
}

/**
 * 销售日报-列表
 * @param {object} params
 * @param {int} params.eId          -eId
 * @param {int} params.begin        -开始时间
 * @param {int} params.end          -结束时间
 * @param {int} params.stage        -科目 0 全部 2 科目2 3 科目3
 * @param {int} params.pageIndex    -索引
 * @param {int} params.pageSize     -容量
 * @param {int} params.purchaseType -支付类型 1 现金支付 2 团购核销 3 历史核销 -1 全部
 */
export function getSalesDaily(params) {
  return request("/report/getSalesDaily", {
    method: "post",
    params: params,
  });
}

/**
 * 获取租车验证码情况-列表
 * @param {object} params
 * @param {int} params.begin         -查询日期起 必填
 * @param {int} params.end           -查询日期止 必填
 * @param {int} params.localTags     -是否本校 0 本校 1 非本校 -1 全部 必填
 * @param {int} params.stage         -科目 全部0 必填
 * @param {int} params.unitId        -单位ID 必填
 * @param {string} params.vehType    -车型 必填
 */
export function trainByDayEnterCodeDetail(params) {
  return request("/report/trainByDayEnterCodeDetail", {
    method: "get",
    params: params,
  });
}

/**
 * 本校学员培训明细-列表
 * @param {object} params
 * @param {int} params.begin         -查询日期起 必填
 * @param {int} params.end           -查询日期止 必填
 * @param {int} params.eid           -是否本校 0 本校 1 非本校 -1 全部 必填
 */
export function postLocalStuTrainDetail(params) {
  return request("/report/getLocalStuTrainDetail", {
    method: "post",
    params: params,
  });
}

/**
 * 本校教练培训明细-列表
 * @param {object} params
 * @param {int} params.begin         -查询日期起 必填
 * @param {int} params.end           -查询日期止 必填
 * @param {int} params.eid           -是否本校 0 本校 1 非本校 -1 全部 必填
 */
export function getLocalTeaMovCarDetail(params) {
  return request("/report/getLocalTeaMovCarDetail", {
    method: "post",
    params: params,
  });
}

/**
 * 用车明细-列表
 * @param {object} params
 * @param {int} params.begin         -查询日期起 必填
 * @param {int} params.end           -查询日期止 必填
 * @param {int} params.eid           -是否本校 0 本校 1 非本校 -1 全部 必填
 */
export function getLocalCarMovDetail(params) {
  return request("/report/getLocalCarMovDetail", {
    method: "post",
    params: params,
  });
}

/**
 * 用车明细-列表
 * @param {object} params
 * @param {int} params.begin         -查询日期起 必填
 * @param {int} params.end           -查询日期止 必填
 * @param {int} params.eid           -是否本校 0 本校 1 非本校 -1 全部 必填
 */
export function getTrainTotalByDateSpan(params) {
  return request("/financeReport/getTrainTotalByDateSpan", {
    method: "post",
    params: params,
  });
}

/**
 * 用车明细-列表
 * @param {object} params
 * @param {int} params.begin         -查询日期起 必填
 * @param {int} params.end           -查询日期止 必填
 * @param {int} params.eid           -是否本校 0 本校 1 非本校 -1 全部 必填
 */
export function getAllocateLogList(params) {
  return request("/report/getAllocateLogList", {
    method: "post",
    params: params,
  });
}

/**
 * 车辆状态-列表
 * @param {object} params
 * @param {int} params.begin         -查询日期起 必填
 * @param {int} params.end           -查询日期止 必填
 * @param {int} params.vehId           -查询日期止 必填
 * @param {int} params.flag           -查询日期止 必填
 * @param {int} params.eid           -是否本校 0 本校 1 非本校 -1 全部 必填
 */
export function getGpsDataByCar(params) {
  return request("/financeReport/getGpsDataByCar", {
    method: "post",
    params: params,
  });
}

/**
 * 本校最后一次定位筛查疑似异常车辆-列表
 * @param {object} params
 * @param {int} params.begin         -查询日期起 必填
 * @param {int} params.end           -查询日期止 必填
 * @param {int} params.eId           -单位电子ID 必填
 */
export function getLastLocationCompareStatistic(params) {
  return request("/report/getLastLocationCompareStatistic", {
    method: "post",
    params: params,
  });
}
